import { render } from "./ChangePassword.vue?vue&type=template&id=1808f15c&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=1808f15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1808f15c"]])

export default __exports__